import { useEffect, useMemo, useState, useRef } from "react";
import { usePostJson } from "../hooks/usePostJson";
import { useAuth } from "../../context/AuthContext";
import  { usStates } from "../../utils/usStates";
import { months, years, service, monthlyConvictionReports, monthlyWithdrawalReports } from "./ReportFiles/months";
import Loading from "./loading";
import Homepage from "../homepage/homepage";

import './Reports.css';

export default function Reports(){
    
  const [currentView, setCurrentView] = useState("home");
  const [reportMode, setReportMode] = useState("weekly");
  const [reportFiles, setReportFiles] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState("");
  const [statusMessage, setStatusMessage] = useState("Ready");
    
  const [beginDate, setBeginDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [rangeStartDate, setRangeStartDate] = useState("");
  const [rangeEndDate, setRangeEndDate] = useState("");
  const [loading, setLoading] = useState();
  const [reportMonth, setReportMonth] = useState("");
  const [reportYear, setReportYear] = useState("2026");
  const [ serviceCenter, setServiceCenter ] = useState("none");
  const [generate, setGenerate] = useState();
  const [showModal, setShowModal] = useState(false);
  const [pendingDelete, setPendingDelete] = useState();
  const [selectedReportType, setSelectedReportType] = useState("");
  //const [ reportList, setReportList ] = useState([]);
  const loadRef = useRef(null)

  const { token, roles } = useAuth();
  
  const defined = (v) => v !== undefined && v !== null && v !== ""
  
  const fetchReports = async () => {
      
        try {
          setLoading(true);
          const response = await fetch('/api/reports', {
            method: 'GET',
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          });
          const result = await response.json();
          setReportFiles(result);
          setStatusMessage("");
          setLoading(false)
        } catch (err) {
          console.error("Failed to fetch reports:", err);
          setError("Failed to load reports from S3.");
          setLoading(false)
        }
      };
      // 2. Fix the async useEffect anti-pattern
      //setLoading(false)
      useEffect(() => {
        fetchReports();
      }, []);
    
  useEffect(() => {
    if (currentView === "disqualifications"|| currentView === "negates") {
      setReportMode("weekly");
    } else if (currentView === "convictions" || currentView === "withdrawals") {
       setReportMode("weekly");
    }
      setError("");
    }, [currentView]);

    const doClear = () => {
      setBeginDate("");
      setEndDate("");
      setReportMonth("");
      setServiceCenter("none");
      setSelectedReportType("");
      setFormErrors({});
    }

    
      const sidebarItems = [
        { label: "Reports Home", icon: "🏠", key: "home" },
        { label: "Convictions Report", icon: "📈", key: "convictions" },
        { label: "Withdrawals Report", icon: "📄", key: "withdrawals" },
        { label: "Disqualifications Report", icon: "🚩", key: "disqualifications" },
        { label: "Negates Report", icon: "❌", key: "negates" },
      ];
    
      const summaryCards = [
        {
          title: "Weekly Disqualifications Status (ALL STATES)",
          value: "1,240",
          description:
            "Individuals currently flagged as Disqualified as of last run (03/08/2026)",
        },
        {
          title: "New Convictions (Last 30 Days)",
          value: "85",
          description: "New convictions added to the database",
        },
        {
          title: "Recent Withdrawals (Last 30 Days)",
          value: "12",
          description: "New withdrawal records processed",
        },
      ];
    
      const homeReportCards = [
        {
          title: "CONVICTIONS REPORT",
          description: "Generates: Monthly Conviction Report, Conviction Worksheet, Monthly Detail Report, and specific Service Centers.",
          icon: "🔎",
        },
        {
          title: "WITHDRAWALS REPORT",
          description: "Generates: Monthly Withdrawal Worksheet, Timeliness Report, and Withdrawal Report.",
          icon: "📄",
        },
        {
          title: "DISQUALIFICATIONS REPORT",
          description: "View and filter current disqualification statuses. Critical for checking the current status of flagged individuals. Options to snapshot current data by date.",
          icon: "🚩",
        },
      ];
    
      const tabs =
        currentView === "disqualifications"
          ? [{ label: "Weekly Report", key: "weekly" }]
          : currentView === "negates"
          ? [
              { label: "Weekly Report", key: "weekly" },
              { label: "Monthly Report", key: "monthly" },
            ]
          : currentView === "convictions" || currentView === "withdrawals"
          ? [
              { label: "Weekly Report", key: "weekly" },
              { label: "Monthly Report", key: "monthly" },
              { label: "Yearly / YTD Report", key: "ytd" },
            ]
          : [];
    
      const filteredFiles = useMemo(() => {

        if(reportFiles.error === 'Failed to list reports from S3'){
          // alert("Error")
          return;
        }

        if (currentView === "home") return reportFiles;
        const mode = currentView === "disqualifications" ? "weekly" : reportMode;
    
        return reportFiles?.filter(
          //(f) => f.reportCategory === currentView && f.reportMode === mode
          (f) => f.type === getCategoryLabel(currentView) && f.dateRange === getModeLabel(reportMode)
        );

      }, [reportFiles, currentView, reportMode]);

      function formatDisplayDate(dateObj) {
        return `${String(dateObj.getMonth() + 1).padStart(2, "0")}/${String(
          dateObj.getDate()
        ).padStart(2, "0")}/${dateObj.getFullYear()}`;
      }
    
      function formatCompactDate(dateObj) {
        return `${dateObj.getFullYear()}${String(dateObj.getMonth() + 1).padStart(
          2,
          "0"
        )}${String(dateObj.getDate()).padStart(2, "0")}`;
      }

      function getModeLabel(){
        if(reportMode === "weekly") return "Weekly";
        if(reportMode === "monthly") return "Monthly"
        return "YTD"
      }
    
      function getCategoryLabel() {
        if (currentView === "convictions") return "Conviction";
        if (currentView === "withdrawals") return "Withdrawal";
        if (currentView === "negates") return "Negate";
        return "Disqualification";
      }
    
      function validate() {
        setError("");
        setStatusMessage("");
        setFormErrors({});
        
        let missingFields = {};

        if (reportMode === "weekly" && currentView !== "disqualifications") {
          if (!beginDate) missingFields.beginDate = true;
          if (!endDate) missingFields.endDate = true;
          
          if (Object.keys(missingFields).length > 0) {
            setError("Beginning Date and End Date are mandatory for weekly reports.");
            setFormErrors(missingFields);
            return false;
          }
        }

        if (reportMode === "monthly") {
          if (!reportMonth) missingFields.reportMonth = true;
          if (!reportYear) missingFields.reportYear = true;
          if (!selectedReportType && (currentView === "convictions" || currentView === "withdrawals")) missingFields.selectedReportType = true;
          
          if (Object.keys(missingFields).length > 0) {
            setError("Month, Year, and Report Type are mandatory for monthly reports.");
            setFormErrors(missingFields);
            return false;
          }
        }
        return true;
      }

      async function doDelete(){
        
        setLoading(true);
        console.log("Deleting key:", pendingDelete);
        try {
          
          const res = await fetch(`/api/reports/delete?key=${encodeURIComponent(pendingDelete)}`,{
            method: 'GET',
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }, 
          }); 

          if (!res.ok) throw new Error("Failed to delete"); 

          const result = await res.json();
          console.log("Delete Report results from UI:", result);
          
        } catch (e) {
          console.error("Error Deleting:", e);
        }

        setLoading(false);
        await fetchReports();
        setShowModal(false);
    }
    
    const handleConfirmDelete = async () => {
        try {
          await doDelete(pendingDelete);
        } catch(e){
           console.error("Error deleting:", e);
        }
      }

      async function setDelete(key){
        setPendingDelete(key);
        setShowModal(true);
      } 

      async function downloadReport(reportKey) 
      {console.log("Downloading key:", reportKey);

        try {
          const response = await fetch(`/api/reports/download?key=${encodeURIComponent(reportKey)}`, {
            method: 'GET',
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          });
          
          if (!response.ok) throw new Error("Failed to fetch download link");

          //alert(JSON.stringify(response))
          
          const result = await response.json();
          console.log("Download Report results from UI:", result);
          
          const finalUrl = typeof result.downloadUrl === 'string' 
             ? result.downloadUrl 
             : result.downloadUrl?.downloadUrl;

           if (!finalUrl) throw new Error('URL missing from response');

           // Trigger the download automatically
           window.location.href = finalUrl;

        } catch (err) {
          console.error("Issue Occurred while downloading:", err);
          setError("Issue Occurred while preparing the download.");
        }

        doClear();
      }

      async function generateReport() {
        if (!validate()) return;
        setGenerate(true)
    
        const now = new Date();
        const generated = formatDisplayDate(now);
    
        let name = "";
        let type = "";

        //alert(serviceCenter)
    
        if (currentView === "disqualifications") {
          const currentRunDate = formatCompactDate(now);
          name = `${currentRunDate} - FCWD Weekly Disqualification Status Report.xlsx`;
          type = "Weekly Status";
        } else if (currentView === "convictions") {
          if (reportMode === "weekly") {
            name = `${endDate.replaceAll("-", "")} - FCWD Weekly Conviction Report.xlsx`;
            type = "Weekly";
          } else if (reportMode === "monthly") {
            const fileDate = rangeEndDate
              ? rangeEndDate.replaceAll("-", "")
              : formatCompactDate(now);
            name = `${fileDate} - FCWD Monthly Conviction Report.xlsx`;
            type = "Monthly";
          } else {
            name = `${now.getFullYear()}YTD - FCWD Conviction Report.xlsx`;
            type = "YTD Pivot";
          }
        } else if (currentView === "withdrawals") {
          if (reportMode === "weekly") {
            name = `${endDate.replaceAll("-", "")} - FCWD Weekly Withdrawal Report.xlsx`;
            type = "Weekly";
          } else if (reportMode === "monthly") {
            const fileDate = rangeEndDate
              ? rangeEndDate.replaceAll("-", "")
              : formatCompactDate(now);
            name = `${fileDate} - FCWD Monthly Withdrawal Report.xlsx`;
            type = "Monthly";
          } else {
            name = `${now.getFullYear()}YTD - FCWD Withdrawal Report.xlsx`;
            type = "YTD Pivot";
          }
        } else if (currentView === "negates") {
          if (reportMode === "weekly") {
            name = `${endDate.replaceAll("-", "")} - FCWD Weekly Negate Report.xlsx`;
            type = "Weekly";
          } else if (reportMode === "monthly") {
            const fileDate = rangeEndDate ? rangeEndDate.replaceAll("-", "") : formatCompactDate(now);
            name = `${fileDate} - FCWD Monthly Negate Report.xlsx`;
            type = "Monthly";
          }
        }

          let mode = "";
          if(["east", "mid", "south", "west"].includes(selectedReportType)){
            const currentRunDate = formatCompactDate(now);
            mode = 'state';
            name = `${currentRunDate} -  FCWD State Conviction Report.xlsx,`
            type = "State"
            
          } else {
            mode = reportMode;
          }

        const newRecord = {
            id: Date.now().toString(),
            reportCategory: currentView,
            reportMode: currentView === "disqualifications" ? "weekly" : mode, //add state as a mode option
            startDate: beginDate,
            endDate: endDate,
            month: reportMonth,
            year: reportYear,     
            serviceCenter: serviceCenter, // selected center {west east south midwest}  
            name,
            type: currentView === "negates" ? "negate_report" : selectedReportType,
            generated,
        };
      

        //alert(JSON.stringify(newRecord))
        const response = await fetch('/api/reports/generate', {
          method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(newRecord)
        })
        const result = await response.json();

        //alert(JSON.stringify(result))
        if(result.error === "Failed to generate report"){ 
          setGenerate(false);
          return }
        console.log("Report generated", result);
        setReportFiles((prev) => [newRecord, ...prev]);
        setStatusMessage(`${getCategoryLabel()} report entry added successfully.`);
        await fetchReports();
  
        setGenerate(false)
      }

   
    
      const pageTitle =
        currentView === "convictions"
          ? "Convictions Reporting Configuration Center"
          : currentView === "withdrawals"
          ? "Withdrawals Reporting Configuration Center"
          : currentView === "negates"
          ? "Negates Reporting Configuration Center"
          : "Disqualifications Reporting Configuration Center";
    
      const descriptionText =
        currentView === "disqualifications"
          ? "View Disqualification Status Report across ALL STATES based on the current run date."
          : currentView === "convictions"
          ? reportMode === "weekly"
            ? "Configure parameters and generate a Weekly Convictions Report across ALL STATES. Beginning Date and End Date are mandatory."
            : reportMode === "monthly"
          ? "Configure parameters and generate a Monthly Convictions Report across ALL STATES."
            : "Configure parameters and generate a Yearly / YTD Convictions Report across ALL STATES."
          : currentView === "negates"
          ? reportMode === "weekly" 
            ? "Configure parameters and generate a Weekly Negates Report. Beginning Date and End Date are mandatory."
            : "Configure parameters and generate a Monthly Negates Report."
          : reportMode === "weekly"
          ? "Configure parameters and generate a Weekly Withdrawals Report across ALL STATES. Beginning Date and End Date are mandatory."
          : reportMode === "monthly"
          ? "Configure parameters and generate a Monthly Withdrawals Report across ALL STATES."
          : "Configure parameters and generate a Yearly / YTD Withdrawals Report across ALL STATES.";
      
      
    if(roles !== null){
        if(!roles.includes("cdlisAdmin")){
            return(<Homepage />)
        }
    }
      
          return (
        <div className="rApp">
          <style>{`
           
          `}</style>
    
          <header className="rApp-header">
         
          </header>
          <div id="rApp-body" className="fcwd-shell">
            <div className="fcwd-layout">
              <aside className="fcwd-sidebar">
                {sidebarItems.map((item) => (
                  <button
                    key={item.key}
                    onClick={() => {setCurrentView(item.key); doClear()}}
                    className={`fcwd-sidebar-btn ${currentView === item.key ? "active" : ""}`}
                    type="button"
                  >
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                ))}
              </aside>
    
              <div className="fcwd-content">
                {currentView === "home" ? (
                  <>
                    <div className="fcwd-card">
                      <h2 className="fcwd-title">Welcome to the FCWD Reporting Dashboard</h2>
                      <p className="fcwd-subtitle">
                        Overview of recent disqualifications, convictions, and withdrawals.
                        Select a specific report from the left menu for full details.
                      </p>
                    </div>
                    <div className="fcwd-grid-3">
                      {homeReportCards.map((card) => (
                        <div key={card.title} className="fcwd-summary-card">
                          <div style={{ textAlign: "right", fontSize: "30px", marginBottom: "16px" }}>
                            {card.icon}
                          </div>
                          <h3>{card.title}</h3>
                          <p>{card.description}</p>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>

                    <div className="fcwd-card">
                      <h2 className="fcwd-title">{pageTitle}</h2>
                      <p className="fcwd-subtitle">{descriptionText}</p>
                    </div>
    
                    <div className="fcwd-tabs">
                      {tabs.map((tab) => (
                        <button
                          key={tab.key}
                          type="button"
                          onClick={() => {setReportMode(tab.key); doClear()}}
                          className={`fcwd-tab ${reportMode === tab.key ? "active" : ""}`}
                        >
                          <span style={{ marginRight: "10px", fontSize: "22px" }}>🗓️</span>
                          {tab.label}
                          {reportMode === tab.key ? <span className="fcwd-tab-pointer" /> : null}
                        </button>
                      ))}
                    </div>
    
                    <div className="fcwd-card-tight">
                      <div id="banner-search">Report Parameters</div>
    
                      <div style={{ padding: "20px" }}>
                        <p className="fcwd-subtitle" style={{ marginTop: 0 }}>
                          {descriptionText}
                        </p>
    
                        {currentView === "disqualifications" ? (
                          <>
                            <button
                              className="fcwd-primary-btn"
                              onClick={generateReport}
                              
                              type="button"
                            >
                              Generate Disqualification Status Report
                            </button>
                            {generate && <Loading />}
                          </>
                        ) : reportMode === "weekly" ? (
                          <>
                            <div className="fcwd-form-grid-2">
                              <div className="fcwd-field">
                                <label className="fcwd-label"><span className="text-danger">*</span> Beginning Date</label>
                                <input
                                  type="date"
                                  value={beginDate}
                                  onChange={(e) => setBeginDate(e.target.value)}
                                  className={`fcwd-input ${formErrors.beginDate ? "required" : ""}`}
                                />
                              </div>
    
                              <div className="fcwd-field">
                                <label className="fcwd-label"><span className="text-danger">*</span> End Date</label>
                                <input
                                  type="date"
                                  value={endDate}
                                  onChange={(e) => setEndDate(e.target.value)}
                                  className={`fcwd-input ${formErrors.endDate ? "required" : ""}`}
                                />
                              </div>
                            </div>
    
                            <button
                              className="fcwd-primary-btn"
                              onClick={generateReport}
                              type="button"
                            >
                              Generate{" "}
                              {currentView === "convictions"
                                ? "Weekly Conviction"
                                : currentView === "withdrawals"
                                ? "Weekly Withdrawal"
                                : "Weekly Negate"}{" "}
                              Report
                            </button>
                            {generate && <Loading />}
                          </>
                        ) : (                   
                          <>                                           
                          <div className="fcwd-form-grid-2">
                            {reportMode && (reportMode === "monthly") && (
                              <div className="fcwd-field">
                                <label className="fcwd-label"><span className="text-danger">*</span> Month:</label>
                                  <select
                                    className={`fcwd-input ${formErrors.reportMonth ? "required" : ""}`}
                                    value={reportMonth}
                                    onChange={(e)=> setReportMonth(e.target.value)}
                                  >
                                    <option>--- Select Month ---</option>
                                      {months.map((v) => (
                                        <option value={v.key}>{v.name}</option>
                                      ))}
                                </select> 
                            </div>
                            )}
                            <div className="fcwd-field">
                                <label className="fcwd-label"><span className="text-danger">*</span> Year:</label>
                                  <select
                                     className={`fcwd-input ${formErrors.reportYear ? "required" : ""}`}
                                    value={reportYear}
                                    onChange={(e)=> setReportYear(e.target.value)}
                                  >
                                 {/*   <option>--- Select Year ---</option> */}
                                      {years.map((v) => (
                                        <option value={v}>{v}</option>
                                      ))}
                                </select> 
                            </div>
                            {reportMode === "monthly" && (
                            <div className="fcwd-field" style={{ gridColumn: "span 2" }}>
                              <label className="fcwd-label"><span className="text-danger">*</span> Select Report to Generate:</label>
                              <select
                                className={`fcwd-input ${formErrors.selectedReportType ? "required" : ""}`}
                                value={selectedReportType}
                                onChange={(e) => setSelectedReportType(e.target.value)}
                              >
                                <option value="">--- Select a Report ---</option>
                                {currentView === "convictions" && monthlyConvictionReports.map(r => (
                                  <option key={r.key} value={r.key}>{r.name}</option>
                                ))}
                                {currentView === "withdrawals" && monthlyWithdrawalReports.map(r => (
                                  <option key={r.key} value={r.key}>{r.name}</option>
                                ))}
                                {currentView === "negates" && (
                                  <option key="negate_report" value="negate_report">Negate Report</option>
                                )}
                              </select>
                            </div>
                          )}
                          </div>
                        
        
                            <button
                              className="fcwd-primary-btn"
                              onClick={generateReport}
                              type="button"
                            >
                            
                              Generate {reportMode === "monthly" ? "Monthly" : "Yearly / YTD"}{" "}
                              {currentView === "convictions" ? "Conviction" : currentView === "withdrawals" ? "Withdrawal" : "Negate"} Report
                            </button>
                               {generate && <Loading />}
                          </>
              
                        )}

                        {error && <div className="fcwd-error">{error}</div>}
                      </div>
                    </div>

                    <div className="fcwd-card-tight">
                      <div id="banner-results">Report Files</div>
    
                      <div style={{ padding: "14px 18px", textAlign: "left", color: "#64748b" }}>
                        {currentView === "disqualifications"
                          ? "Viewing status-based weekly all-state Excel workbooks for disqualifications."
                          : `Viewing ${reportMode} report files for ${
                              currentView === "convictions" ? "convictions" : currentView === "withdrawals" ? "withdrawals" : "negations"
                            }.`}
                      </div>
    
                      <div className="table-scroll-container">
                        {loading && <Loading />}
                        <div className="fcwd-table-header">
                          <div>Report Name</div>
                          <div>Type</div>
                          <div>Generated</div>
                          <div>Action</div>
                        </div>

                        {defined(filteredFiles) ? (
                          filteredFiles.map((f) => (
                            <div key={f.id} className="fcwd-table-row">
                              <div className="fcwd-file-name">
                                <span>📗</span>
                                <span>{f.name}</span>
                              </div>
                              <div>{f.type}</div>
                              <div>{f.generatedDate}</div>
                              <div>
                                <button 
                                  className="fcwd-file-btn" 
                                  onClick={() => downloadReport(f.key)}
                                  type="button">
                                  Download
                                </button>
                                &nbsp;&nbsp;
                                <button 
                                  className="fcwd-file-btn" 
                                  type="button"
                                  onClick={() => setDelete(f.key)}
                                >
                                  <span> &#x1F5D1;</span>
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="fcwd-empty">No report files available.</div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {showModal && (
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Deletion</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    />
                  </div>
                  <div className="modal-body">
                    <p>
                      Are you sure you want to delete the report
                      This action cannot be undone.
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleConfirmDelete}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
            )} 
          </div>
          </div>
        );
      }
    